import React, { useEffect } from "react";
import "../../stepper.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomerInput from "../reusableComponents/CustomerInput";
import FilterEmailInput from "../reusableComponents/FilterEmailInput";
import FilterPhoneInput from "../reusableComponents/FilterPhoneInput";
import logo from "../../img/BBP.png";

const StaffFilters = ({
  ClearFilter,
  ApplyFilter,
  handleChangeNameFilter,
  handleChangeEmailFilter,
  handleChangePhoneFilter,
  filterCustomerName,
  filterCustomerEmail,
  filterCustomerPhone,
  ExportData,
  ExportType,
}) => {
  const details = useSelector((state) => state.details.details);
  const lastCompletedStep = details?.result?.lastCompletedStep;
  const location = useLocation();
  const route = location.pathname.split("/").pop();
  useEffect(() => {
    console.log(route);
  }, []);

  return (
    <>
      <div div className="grid mt-5 grid-cols-12 gap-4 mb-5">
        <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3">
          <label
            htmlFor="customer"
            className="block text-md font-medium leading-6 text-gray-900"
          >
            Name
          </label>
          <CustomerInput
            onChange={handleChangeNameFilter}
            value={filterCustomerName || ""}
          />
        </div>
        <div className="col-span-12 sm:col-6 md:col-span-6 lg:col-span-3 ">
          <label
            htmlFor="email"
            className="block text-md font-medium leading-6 text-gray-900"
          >
            Email
          </label>
          <FilterEmailInput
            onChange={handleChangeEmailFilter}
            value={filterCustomerEmail}
          />
        </div>
        <div className="col-span-8 sm:col-5 md:col-span-6 lg:col-span-3">
          <label
            htmlFor="phone"
            className="block text-md font-medium leading-6 text-gray-900"
          >
            Phone
          </label>
          <FilterPhoneInput
            onChange={handleChangePhoneFilter}
            className="mobile"
            value={filterCustomerPhone}
          />
        </div>
        <div className="col-span-4 md:col-span-5 lg:col-span-3 ">
          <div className="flex mt-7">
            <div
              onClick={ApplyFilter}
              className="p-2 hover:cursor-pointer bg-sky-600 mr-2 rounded-md text-white"
            >
              Apply Filter
            </div>
            <div
              onClick={ClearFilter}
              className=" border-gray-200 bg-gray-200 p-2 rounded-md hover:cursor-pointer"
            >
              Clear Filter
            </div>
          </div>
        </div>
      </div>
      <div className="text-right">
        <button
          name={ExportType}
          onClick={ExportData}
          className="p-2 hover:cursor-pointer bg-red-500 rounded-sm text-xs text-white"
        >
          Export Data
        </button>
      </div>
    </>
  );
};

export default StaffFilters;
